import { render, staticRenderFns } from "./AdUnitsPendingApprovalModalEx.vue?vue&type=template&id=fd00772e&scoped=true&shadow"
import script from "./AdUnitsPendingApprovalModalEx.vue?vue&type=script&lang=js&shadow"
export * from "./AdUnitsPendingApprovalModalEx.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fd00772e",
  null
  ,true
)

export default component.exports